
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface DentalPlanCardProps {
  title: string;
  originalPrice: string;
  discountedPrice: string;
  features: string[];
  recommended?: boolean;
  image?: string;
}

export const DentalPlanCard = ({
  title,
  originalPrice,
  discountedPrice,
  features,
  recommended = false,
  image
}: DentalPlanCardProps) => {
  const navigate = useNavigate();

  const handleBookAppointment = () => {
    window.open("https://www.healthcoco.com/nagpur/doctor/dr-hemant-asrani-endodontist-dentist/USRH249D644", "_blank");
  };

  return (
    <div className={`bg-white rounded-xl shadow-soft overflow-hidden transition-all duration-300 hover:shadow-lg ${recommended ? 'border-2 border-dental-highlight relative scale-105 z-10' : ''}`}>
      {recommended && (
        <div className="absolute top-0 right-0 bg-dental-highlight text-white px-4 py-1 text-sm font-medium">
          Recommended
        </div>
      )}
      
      {image && (
        <div className="h-48 overflow-hidden">
          <img 
            src={image} 
            alt={title} 
            className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
          />
        </div>
      )}
      
      <div className="p-6">
        <h3 className="text-xl font-serif font-medium mb-4">{title}</h3>
        
        <div className="flex items-baseline mb-6">
          <span className="text-dental-muted line-through text-sm mr-2">{originalPrice}</span>
          <span className="text-dental-highlight text-2xl font-semibold">{discountedPrice}</span>
        </div>
        
        <ul className="space-y-3 mb-6">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <Check size={18} className="text-dental-highlight mt-1 mr-2 flex-shrink-0" />
              <span className="text-dental-text">{feature}</span>
            </li>
          ))}
        </ul>
        
        <Button 
          onClick={handleBookAppointment}
          className={`w-full ${recommended ? 'bg-dental-highlight hover:bg-dental-highlight/90' : 'bg-dental-accent hover:bg-dental-accent/90'}`}
        >
          Book Now
        </Button>
      </div>
    </div>
  );
};
